<template>
    <svg :class="{'rotate': dir === 'rtl'}" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height"
         viewBox="0 0 11.869 19.87">
        <path id="Path_70076" data-name="Path 70076" d="M241.8,1831.883l-8.852,8.169,8.852,8.169"
              transform="translate(-231.702 -1830.116)" fill="none" :stroke="stroke" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="2.5"/>
    </svg>
</template>

<script>
    export default {
        name: "IBack",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            },
            stroke: {
                type: String,
                default: '#fff'
            }
        },
        data: () => ({
            dir: document.querySelector('body').getAttribute('dir')
        })
    }
</script>

<style scoped>
    .rotate {
        transform: rotate(180deg);
    }
</style>
